import { Converter } from '../types/converter';

export const magneticFluxDensityConverter: Converter = {
  id: 'magneticFluxDensity',
  name: 'Magnetic Flux Density Converter',
  icon: 'Magnet',
  categories: ['magnetism'],
  units: [
    // SI unit
    { name: 'Tesla', symbol: 'T', factor: 1 },
    
    // Weber-based units
    { name: 'Weber per square meter', symbol: 'Wb/m²', factor: 1 },
    { name: 'Weber per square centimeter', symbol: 'Wb/cm²', factor: 10000 },
    { name: 'Weber per square inch', symbol: 'Wb/in²', factor: 1550.0031 },
    
    // Maxwell-based units
    { name: 'Maxwell per square meter', symbol: 'Mx/m²', factor: 1e-8 },
    { name: 'Maxwell per square centimeter', symbol: 'Mx/cm²', factor: 1e-4 },
    { name: 'Maxwell per square inch', symbol: 'Mx/in²', factor: 1.5500031e-5 },
    
    // Gauss and related units
    { name: 'Gauss', symbol: 'G', factor: 1e-4 },
    { name: 'Line per square centimeter', symbol: 'line/cm²', factor: 1e-4 },
    { name: 'Line per square inch', symbol: 'line/in²', factor: 1.5500031e-5 },
    { name: 'Gamma', symbol: 'γ', factor: 1e-9 }
  ]
};
